import React from 'react';

interface SendIconProps {
    width?: number;
    height?: number;
    color?: string;
    className?: string;
}

const Send: React.FC<SendIconProps> = ({
    width = 24,
    height = 24,
    color = "currentColor",
    className = ""
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M2.01 21L23 12L2.01 3L2 10L17 12L2 14L2.01 21Z"
                fill={color}
            />
        </svg>
    );
};

export default Send; 